// const productContainer = document.querySelector('.product-section');

// if (productContainer) {
//     productContainer.querySelectorAll('.variant-input').forEach(input => {
//         input.querySelector('.variant__button-label').addEventListener('click', function (e) {
//             variantChange(this.dataset.productHandle, this.dataset.variantId)
//         })
//     });
// }


if(!customElements.get('product-wrapper')) {
    customElements.define('product-wrapper', 
        class ProductWrapper extends HTMLElement {
            constructor () {
                super();

                let _this = this;

                // this.productImageSlider();

                this.querySelectorAll('.variant-input').forEach(input => {
                    input.querySelector('.variant__button-label').addEventListener('click', function (e) {
                        fetch(`/products/${e.target.dataset.productHandle}?variant=${e.target.dataset.variantId}&view=refresh`)
                        .then(res => {
                            return res.text();
                        }).then(resText => {

                            const html = new DOMParser().parseFromString(resText, 'text/html')

                            let sourceTitle = _this.querySelector('.product-single__title');
                            let targetTitle = html.querySelector('.product-single__title');

                            if(sourceTitle && targetTitle) sourceTitle.innerHTML = targetTitle.innerHTML

                            let sourcePhotos = _this.querySelector('.product__main-photos');
                            let targetPhotos = html.querySelector('.product__main-photos');

                            // if(sourcePhotos && targetPhotos) sourcePhotos.innerHTML = targetPhotos.innerHTML

                            let sourceThumbs = _this.querySelector('.product__thumbs');
                            let targetThumbs = html.querySelector('.product__thumbs');

                            // if(sourceThumbs && targetThumbs) sourceThumbs.innerHTML = targetThumbs.innerHTML

                            let sourcePrice = _this.querySelector('.product-block--price');
                            let targetPrice = html.querySelector('.product-block--price');

                            // if(sourcePrice && targetPrice) sourcePrice.innerHTML = targetPrice.innerHTML

                            let sourceDescription = _this.querySelector('.product_description .collapsible-content__inner');
                            let targetDescription = html.querySelector('.product_description .collapsible-content__inner');

                            if(sourceDescription && targetDescription) sourceDescription.innerHTML = targetDescription.innerHTML

                            let sourceBreadcrumb = _this.querySelector('.breadcrumb__current');
                            let targetBreadcrumb = html.querySelector('.breadcrumb__current');

                            // if(sourceBreadcrumb && targetBreadcrumb) sourceBreadcrumb.innerHTML = targetBreadcrumb.innerHTML
                          
                        }).finally(() => {
                            // _this.productImageSlider();
                        })
                    })
                });
            }

            // productImageSlider() {
            //     var galleryThumbs = new Swiper(".product__thumbs", {
            //         // centeredSlides: true,
            //         slidesPerView: "auto",
            //         direction: 'vertical'
            //     });
        
            //     var galleryMain = new Swiper(".product__main-photos", {
            //         slidesPerView : 1,
            //         direction : "horizontal",
            //         spaceBetween : 10,
            //         navigation: {
            //           nextEl: '.swiper-button-next',
            //           prevEl: '.swiper-button-prev',
            //         },
            //         thumbs: {
            //           swiper: galleryThumbs
            //         }
            //     });
            // }

        }
    )
}